import React from 'react'
import {getDirection, register} from '../utils'
import {handle, useEvent} from '../events'
import {getState} from '../game-surface'
import {addGameObject} from '../system'
import {Line} from 'react-konva'
import {sprite} from '../system/sprite'
import {proportional} from '../proportional'
import {useSpring} from 'react-spring'
import {playSound, registerSound} from '../sound'

const attach = registerSound('/attach.mp3')
const drop = registerSound('/laser gun shot.mp3')

let dragBox
export const dragged = register('dragged', {
    postInitialize() {
        dragBox = this.$
        this.$.transform.Sprite = this.Sprite.bind(this)
    },
    methods: {
        Sprite,
    },
    states: {
        default: {
            enter() {
                this.$.visible = false
            },
        },
        moving: {
            enter() {
                this.$.visible = true
            },
            methods: {
                Update(dt) {
                    const {stage, rocket} = getState()
                    const position = stage.getPointerPosition()
                    position.x = proportional(position.x, true)
                    position.y = proportional(position.y, true)
                    this.$.x = position.x
                    this.$.y = position.y
                    let closest = null
                    let distance = Infinity
                    for (let mount of rocket.parts) {
                        let [{ok}] = mount.api.canTake({ok: false})
                        if (!ok) continue
                        const {l, ...dir} = getDirection(
                            mount.position(),
                            position
                        )
                        if (l < distance) {
                            closest = mount
                            distance = l
                        }
                    }
                    if (distance < 80) {
                        this.$.currentPart = closest
                        this.$.lineColor = 'lightgreen'
                    } else {
                        this.$.currentPart = null
                        this.$.lineColor = 'white'
                    }
                },
            },
        },
    },
})

function Sprite() {
    useEvent('stage.mouseUp', () => {
        if (this.$.currentPart) {
            const {l, ...dir} = getDirection(
                this.$.currentPart.position(),
                this.$
            )
            playSound(attach)
            this.$.currentPart.api.take(this.$.points, {
                x: dir.x * l,
                y: dir.y * l,
            })
        } else {
            playSound(drop)
        }
        this.$.setState('default')
    })
    const props = useSpring({
        lineColor: this.$.lineColor || 'white',
        config: {mass: 3, tension: 250, friction: 30},
    })

    return (
        <Line
            points={this.$.points}
            closed={true}
            fill={'rgba(255,255,255,0.4'}
            stroke={props.lineColor.getValue()}
            strokeWidth={6}
            tension={0.3}
        />
    )
}

export function drag(points) {
    dragBox.points = [...points]
    dragBox.setState('moving')
}

handle('initializeGame', () => {
    addGameObject({z: 3000}, {sprite, dragged})
})
